import React, {Component, h, Fragment} from "preact";
import {AppPage} from "../_common/components/app-page";
import { DateTime } from 'luxon';
import {connect} from "react-redux";
import {
    fetchOfferPreview,
    clearOfferPreview,
    fetchSchedules,
    fetchAcademicPrograms,
    updateOfferStatus,
    fetchContractTypes,
    fetchStates
} from "../_rx/jobs/actions";
import {CF, C, E, R, Card, FR} from "../_common/layout";
import {t} from "../_i18n";
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import Badge from "../_common/components/Badge";

const UNPUBLISHED: string = 'unpublished';
const PUBLISHED: string = 'published';


const REMOTE: string = 'remote';

type Props = {
    fetchOfferPreview: typeof fetchOfferPreview,
    clearOfferPreview: typeof clearOfferPreview,
    fetchSchedules: typeof fetchSchedules,
    fetchAcademicPrograms: typeof fetchAcademicPrograms,
    fetchContractTypes: typeof fetchContractTypes,
    updateOfferStatus: typeof updateOfferStatus,
    fetchStates: typeof fetchStates,
    location: any,
    previewOffer: any,
    academic_programs: any,
    states: any,
    company: any,
    contract_types: any,
    schedules: any,
    match: any,
    history: any,
}

class View extends Component<Props, any> {

    logoBase = window.env.JOBS_API_basePath;
    componentDidMount() {
        this.props.fetchOfferPreview({id: this.props.match.params.id});

        if(!this.props.schedules)
            this.props.fetchSchedules();
        if(!this.props.academic_programs)
            this.props.fetchAcademicPrograms();
        if(!this.props.contract_types)
           this.props.fetchContractTypes();
        if(!this.props.states)
            this.props.fetchStates();
    }

    componentWillUnmount() {
        this.props.clearOfferPreview()
    }

    handleClick = () => {
        this.props.history.goBack();
    }

    handleChangeStatus = async (status: string) => {
        const {previewOffer, updateOfferStatus} = this.props
        await updateOfferStatus({id: previewOffer.id, status: {status: status}})
        this.props.history.push('/offers')
    }

    renderDate = (date: number) => {
        return DateTime.fromMillis(date)
            .setLocale('es')
            .toFormat("dd LLL yyyy 'a las 'HH:mm")
    }


    render = ({previewOffer, schedules, company, academic_programs, contract_types}: Props) => {

        return (previewOffer && schedules && academic_programs && contract_types) && <CF className='max-width-980'>
            {this.props.history.length > 0 && <nav className="breadcrumb-wrapper p-x2-bottom">
                <button onClick={this.handleClick} className="back breadcrumb-item without-background"><span
                    className="font-16"><i className="fal fa-long-arrow-left" aria-hidden="true" /> {t('Volver')}</span></button>
            </nav>}
            <Helmet>
                <title>{previewOffer.title + ' | ILERNA'}</title>
            </Helmet>
            <Card className='m-bottom'>
                <E>
                    <FR>
                        <E className='sm-col-80 col-70'>
                            <h1 className='font-medium'>{previewOffer.title}</h1>
                        </E>
                        <E className='sm-col-20  col-30 d-flex flex-right'>
                            {
                                (company.logo)
                                    ? <div className='card image-squared'
                                           style={`background-image:url('${this.logoBase}/company/view-logo/${company.logo}');`}/>
                                    : <div className='card image-squared'/>
                            }
                        </E>
                    </FR>
                </E>
                <E>
                    {previewOffer.displayCompanyName ? <Link to={'/company/preview'}
                                                             className="no-decoration t-upper text-info font-light sm-d-line d-block">{previewOffer.companyName}
                            <span className="d-none sm-d-iblock">&nbsp;</span></Link>
                        : <span
                            className="no-decoration t-upper text-info font-light sm-d-line d-block">{previewOffer.companyName}</span>
                    }
                    <span className='p-left p-right d-none sm-d-line'>-</span>
                    {
                        (previewOffer.presence === REMOTE)
                            ? <span className='translucent m-top'>{t('Teletrabajo')}</span>
                            : <span
                                className='font-light sm-d-line d-block translucent m-top'>{previewOffer.city}{` (${this.props.states[previewOffer.state]})`}</span>
                    }

                </E>
                <E>
                    {(contract_types) && <span
                        className='sm-d-line d-block p-bottom sm-no-p-bottom'>{contract_types[previewOffer.contractType]}</span>}
                    {(previewOffer.length) && <Fragment>
                        <span className='p-left d-none sm-d-line'>-</span>
                        <span
                            className='sm-p-left sm-d-line d-block p-bottom sm-no-p-bottom'>Contrato {previewOffer.length}</span>
                        <span className='p-left d-none sm-d-line'>-</span>
                    </Fragment>}
                    <span
                        className='sm-m-l no-margin-left font-light sm-d-line d-block p-bottom sm-no-p-bottom'>Jornada {schedules[previewOffer.schedule]}</span>
                    {(previewOffer.salaryMin) && <Fragment>
                        <span className='p-left d-none sm-d-line'>-</span>
                        <span
                            className='p-left font-light sm-d-line d-block p-bottom sm-no-p-bottom'>{previewOffer.salaryMin} €</span>
                    </Fragment>}
                    {(previewOffer.salaryMax) && <Fragment>
                        <span className='font-light p-left d-none sm-d-line'>-</span>
                        <span
                            className='p-left font-light sm-d-line d-block p-bottom sm-no-p-bottom'>{previewOffer.salaryMax} €</span>
                    </Fragment>}
                    {(previewOffer.salaryType) && <span className='font-light p-left'>{previewOffer.salaryType}</span>}
                    {previewOffer.maxJobs &&
                    <span className='sm-d-line d-block p-bottom sm-no-p-bottom font-color-486268'>
                    <span className='font-light no-margin-left sm-m-l d-none sm-d-line'>-</span>
                    <span
                        className='no-margin-left sm-m-l'>{previewOffer.maxJobs} {previewOffer.maxJobs > 1 ? t('vacantes') : t('vacante')}</span>
                </span>}
                    {(previewOffer.modality == 'fct') && <span
                        className='sm-m-l m-l m-top-half sm-m-r m-r no-margin-bottom font-medium'>{t('Formación en centro de trabajo')}</span>}
                    {(previewOffer.isRemoteProcess) && <Badge type='double-green' className='t-upper m-l-half sm-m-r m-top-half no-margin-left font-12'><span>{t('proceso online')}</span></Badge>}

                </E>
                <E className='m-top'>
                    <FR className='md-flex-right'>
                        <E className='sm-col-30 col-100'>
                            <Link to={'/offers/' + previewOffer.id + '/edit'} className='no-decoration'>
                                <div className="btn btn-ghost info  m-top"><span
                                    className="text-info text-normal t-upper">{t('Editar Oferta')}</span></div>
                            </Link>
                        </E>

                        {(previewOffer.status === UNPUBLISHED) &&
                        <E className='sm-col-30 col-100'>
                            <div className="btn btn-ghost info  m-top"
                                 onClick={() => this.handleChangeStatus('published')}><span
                                className={'text-info text-normal t-upper'}>{t('Publicar')}</span></div>
                        </E>
                        }
                        {(previewOffer.status === PUBLISHED) &&
                        <E className='sm-col-30 col-100'>
                            <div className="btn btn-ghost danger  m-top"
                                 onClick={() => this.handleChangeStatus('closed')}><span
                                className={'text-danger text-normal t-upper'}>{t('Cerrar Proceso')}</span></div>
                        </E>
                        }
                    </FR>
                </E>
            </Card>
            <Card className='p-bottom background-white sm-background-body'>
                <FR className='sm-no-flex-column flex-column'>
                    <E className='sm-col-20 col-100 p-left sm-no-p-left'>
                        <h2 className='font-medium text-default'>Titulación</h2>
                    </E>
                    <E className='sm-col-80 col-100 p-left sm-no-p-left'>
                        {(academic_programs) && previewOffer.academicPrograms.map((academicProgram: number) => (
                            <div>
                                <Badge type='info' className='m-r light m-top'><span>{academic_programs[academicProgram]}</span></Badge>
                            </div>))}
                    </E>
                </FR>
                <hr className="separator-xxs"/>
                <FR className='sm-no-flex-column flex-column'>
                    <E className='sm-col-20 col-100 p-left sm-no-p-left'>
                        <h2 className='font-medium text-default'>Requisitos</h2>
                    </E>
                    <E className='sm-col-80 col-100 m-top preserve-lines p-left sm-no-p-left'>
                        <div className='editor-class-text'
                             dangerouslySetInnerHTML={{__html: previewOffer.requirements}}/>
                    </E>
                </FR>
                <hr className="separator-xxs"/>
                <FR className='sm-no-flex-column flex-column'>
                    <E className='sm-col-20 col-100 p-left sm-no-p-left'>
                        <h2 className='font-medium text-default'>Descripción</h2>
                    </E>
                    <E className='sm-col-80 col-100 m-top preserve-lines p-left sm-no-p-left'>
                        <div className='editor-class-text' dangerouslySetInnerHTML={{__html: previewOffer.text}}/>
                    </E>
                </FR>
                {previewOffer.modality !== "fct" &&
                <Fragment>
                    <hr className="separator-xxs"/>
                    <FR className='sm-no-flex-column flex-column'>
                        <E className='sm-col-20 col-100 p-left sm-no-p-left'>
                            <h2 className='font-medium text-default'>Beneficios</h2>
                        </E>
                        <E className='sm-col-80 col-100 p-left sm-no-p-left'>
                            {(previewOffer.benefits) && previewOffer.benefits.map((benefit: string) =>
                                <div>
                                    <Badge type='info' className='m-r light m-top'><span>{benefit}</span></Badge>
                                </div>)}

                            {(previewOffer.benefitsText) && previewOffer.benefitsText.split(',').map((benefit_text: string) =>
                                <div>
                                    <Badge type='info' className='m-r light m-top'><span>{benefit_text}</span></Badge>
                                </div>
                            )}

                        </E>
                    </FR>
                </Fragment>
                }
            </Card>
            <div className="p-top sm-flex-right flex-left sm-d-flex">
                <span>
                    {(previewOffer.status === UNPUBLISHED) ? 'Última modificación:' : 'Oferta publicada:'} {this.renderDate(previewOffer.date)}</span>
            </div>
        </CF>

    }
}


const ConnectedView: any = connect(
    ({offerReducer:{previewOffer}, fixtures:{schedules, academic_programs, contract_types, states}, company}: any)=>({previewOffer, schedules, academic_programs, contract_types, company, states}),
    { fetchOfferPreview, clearOfferPreview, fetchSchedules, fetchAcademicPrograms, fetchContractTypes, updateOfferStatus, fetchStates })(View as any);

export default ({history, ...rest}: any) =>
    <AppPage
        name="offer-preview"
        subtitle=""
        className="max-width-980">
        <ConnectedView {...rest} history={history} />

    </AppPage>
;
